"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerTheme = registerTheme;

var _dynamicCSS = require("./dynamicCSS");

var _utils = require("./utils");

// const dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
// const varPrefix = `enphase`;
var dynamicStyleMark = "-enphase-designsystems";

function getStyle(theme) {
  var variables = {};
  Object.keys(theme).forEach(key => {
    if (typeof theme[key] === 'object' && !Array.isArray(theme[key])) {
      Object.keys(theme[key]).forEach(t => variables["".concat(key, "-").concat(t)] = theme[key][t]);
    } else {
      variables[key] = theme[key];
    }
  });
  var cssList = Object.keys(variables).map(key => "--".concat(key, ": ").concat(variables[key], ";") // key => `--${varPrefix}-${key}: ${variables[key]};`,
  );
  return "\n  :root {\n    ".concat(cssList.join('\n'), "\n  }\n  ").trim();
}

function registerTheme(theme) {
  var style = getStyle(theme);

  if ((0, _utils.canUseDom)()) {
    (0, _dynamicCSS.updateCSS)(style, "".concat(dynamicStyleMark, "-theme"));
  } else {
    console.warn(false, 'ConfigProvider', 'SSR do not support theme with css variables.');
  }
}